.editor {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 12px;
  background: var(--card-bg);
  border-left: 4px solid var(--blue);
  border-bottom: 1px solid var(--border);
}

.row {
  display: flex;
  gap: 9px;
  align-items: center;
  flex-wrap: wrap;
}

.label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  color: var(--text2);
}

.number {
  width: 72px;
  padding: 6px 9px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--input-bg);
  color: var(--text);
}

.text {
  flex: 1;
  min-width: 140px;
  padding: 6px 9px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--input-bg);
  color: var(--text);
}

.buttons {
  display: flex;
  gap: 7px;
}

.button {
  padding: 7px 13px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
  line-height: 1;
}

.save {
  background: var(--action-save);
  color: #fff;
}
.delete {
  color: var(--action-danger);
  background: var(--card-bg);
  border: 1px solid color-mix(in srgb, var(--action-danger) 40%, transparent);
}
.delete:hover {
  color: #fff;
  background: var(--action-danger);
}
.cancel {
  background: var(--border);
  color: var(--text);
}

/* Сообщение об ошибке показывается прямо в форме, а не под схемой:
   стойка бывает высотой в 42 юнита, и сообщение внизу оказалось бы
   за пределами экрана — выглядело бы так, будто ничего не произошло. */
.error {
  padding: 7px 10px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--action-danger);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

@media (max-width: 640px) {
  .editor {
    padding: 12px 10px;
  }
  .row {
    flex-direction: column;
    align-items: stretch;
  }
  .text,
  .number {
    width: 100%;
  }
  .label {
    justify-content: space-between;
  }
  .label .number {
    width: 90px;
    flex: none;
  }
  .buttons {
    display: flex;
  }
  .button {
    flex: 1;
    padding: 10px;
    font-size: 15px;
  }
}
